import axios from 'axios';
import LoginCredentials from '@core/models/authentication/LoginCredentials';
import config from '@config';
import RegisterInput from '@countryModels/authentication/RegisterInput';
import CTRestRequestFactory from '@core/utils/network/CTRestRequestFactory';

export default class RestService {
    private readonly request: any;
    private validFieldCancelSource: any = {};

    constructor(restRequestFactory = CTRestRequestFactory) {
        this.request = restRequestFactory.create(config.services.auth.host, true);
    }

    /**
     * @throws {RequestError}
     */
    public register(registerInput: RegisterInput): Promise<any> {
        registerInput.repeatpassword = registerInput.password;
        return this.request({
            url: `/user/${config.countrySpecific.auth.registerUrl}`,
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: registerInput,
        });
    }

    /**
     * @throws {RequestError}
     */
    public isRegisterFieldValid(key: string, value: string): Promise<any> {
        if (this.validFieldCancelSource[key] && this.validFieldCancelSource[key] !== null) {
            this.validFieldCancelSource[key].cancel();
            this.validFieldCancelSource[key] = null;
        }

        const CancelToken = axios.CancelToken;
        this.validFieldCancelSource[key] = CancelToken.source();

        return this.request({
            url: '/user/checkUserDataIntegrity',
            cancelToken: this.validFieldCancelSource[key].token,
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                data: {
                    [key]: value
                }
            },
        });
    }

    /**
     * @throws {RequestError}
     */
    public login(loginCredentials: LoginCredentials): Promise<any> {
        return this.request({
            url: '/session/login',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: loginCredentials,
        });
    }

    /**
     * @throws {RequestError}
     */
    public getSession(): Promise<any> {
        return this.request({
            url: '/session/getSession',
            method: 'get',
        });
    }

    /**
     * @throws {RequestError}
     */
    public logout(): Promise<any> {
        return this.request({
            url: '/session/logOut',
            method: 'get',
        });
    }

    /**
     * @throws {RequestError}
     */
    public activateAccount(token: string): Promise<any> {
        return this.request({
            url: '/user/activateWithLogin',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                secureKey: token
            },
        });
    }

    /**
     * @throws {RequestError}
     */
    public updatePassword(oldPassword: string, newPassword: string): Promise<any> {
        return this.request({
            url: '/user/updatePassword ',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                password: oldPassword,
                newpassword: newPassword,
                repeatpassword: newPassword,
            },
        });
    }

    /**
     * @throws {RequestError}
     */
    public forgotPasswordRequest(email: string): Promise<any> {
        return this.request({
            url: '/user/forgotPassword ',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                emailAddress: email,
            },
        });
    }

    /**
     * @throws {RequestError}
     */
    public changeForgottenPassword(token: string, password: string): Promise<any> {
        return this.request({
            url: '/user/changeForgottenPassword ',
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                secureKey: token,
                newPassword: password
            },
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/authentication/_private/RestService.ts